export default "__VITE_ASSET__BLxbjWuw__"